import * as React from 'react';

import { useTranslation } from 'react-i18next';

import { ItemsProvider } from '@common/react/components/Core/ItemsProvider/ItemsProvider';
import LoadMoreButton from '@common/react/components/Core/ItemsProvider/LoadMoreButton';
import { List } from '@common/typescript/objects/List';

import { PageDoctor } from '@commonTuna/react/objects/BaseDoctor';

import ServiceCard from '@app/components/Pages/Service/ServiceCard';

interface PageDoctorsProps {
	items: List<PageDoctor>;
	doctorId: number;
}

const PageDoctors: React.FC<PageDoctorsProps> = ({
	items,
	doctorId,
}) => {
	const { t } = useTranslation();

	return (
		<ItemsProvider
			items={items.list}
			pagination={{
				current: 1, pageSize: 8, total: items.count,
			}}
			loadRequest="pageDoctorListRemote"
			filters={{
				doctorId,
				count: 8,
			}}
		>
			{({ state: { items } }) => items?.length > 0 && <div className="service-page__faq service-page__block">
				<div className="sub-pages service-page__block row">
					{items.map((child: PageDoctor) => <ServiceCard key={child.id} page={child.page} />)}
				</div>
				<div className="text-center">
					<LoadMoreButton
						className="general-form-button general-form-button_sm"
					>
						{t('site.Load More')}
					</LoadMoreButton>
				</div>
			</div>}
		</ItemsProvider>
	);
};

export default PageDoctors;
